/**
 * @format
 */

export interface SelectedElement {
   templateVariable: string;
   originalValues: string[];
   containerRef: HTMLElement;
   innerHtmlSelected: string;
   anchorNode: any;
   parameterParentElement: any;
   isParameter: boolean;
}

export class OriginalAndStyledValue {
   original: string;
   styled: string;
   constructor(original: string, styled: string) {
      this.original = original;
      this.styled = styled;
   }
}

export interface TemplateVariableElement {
   htmlElement: HTMLElement;
   id: string;
}

export class FontStyles {
   fontFamily: string;
   fontSize: string;
   fontColor: string;
   constructor(fFamily: string, fSize: string, fontColor: string) {
      this.fontFamily = fFamily || "Montserrat";
      this.fontSize = fSize || "15px";
      this.fontColor = fontColor || "#ffffff";
   }
}

export interface DropDownFont {
   name: string;
   value: string;
}

export interface DropDownFontItem extends DropDownFont {
   id: number;
}

export type AlignmentType = "LEFT" | "CENTER" | "RIGHT";

export type ModelVariableId = string;

export type ContentAndModelId = Record<ModelVariableId, string>;

export class Styles {
   isBold: boolean;
   isUnderLine: boolean;
   fontFamily: string;
   fontSize: string;
   fontColor: string;
   textAlignment: string;
}

export type RangeOffset = { start: number; end: number };

export type ShortcutTypes = "UNDERLINE" | "BOLD" | "UNDO" | "SELECT_ALL";

export type FontChangeType = "FONT_SIZE" | "FONT_COLOR" | "FONT_FAMILY";

export interface FontStyleArgument {
   property: StyleProperty;
   value: string;
}

export type StylingStatus = "STYLING" | "NOT-STYLING" | "KEEP-STYLE";

export type StyleProperty = "font-family" | "color" | "font-size";

export type SelectionType = "IN_SELECTION" | "OUT_SELECTION";

export type ToolType = "BOLD" | "UNDERLINE";
export class StackItemNode {
   readonly id: string;
   readonly nodeName: string;
   readonly style: string;
   readonly isBoundary: boolean;
   readonly previousStyle: string;

   constructor(node: string | Node, style?: string, customId?: string, prevStyle?: string) {
      this.id = customId || new Date().getTime().toString();
      this.isBoundary = Boolean(customId); // if it has custom id then is boundary
      this.previousStyle = prevStyle || "";

      if (typeof node === "string") {
         this.nodeName = node.toLowerCase();
         this.style = style || "";
      } else {
         this.nodeName = (<Element>node).nodeName.toLowerCase();
         this.style = (<Element>node).getAttribute("style") || "";
      }
   }
}

export type StyleRecord = "fontFamily" | "color" | "fontSize" | "bold" | "underline" | "alignment";
